import { Component, OnInit, HostListener, ViewChild, ElementRef, Input, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-main-slide',
  templateUrl: './main-slide.component.html',
  styleUrls: ['./main-slide.component.scss'],
})
export class MainSlideComponent implements OnInit {
  @ViewChild('mainSlide') mainSlide: ElementRef;

  menu: boolean = false;
  initModal: boolean = false;
  appViaje: boolean = false;
  appBeneficios: boolean = false;

  public smallHeader = false;
  @Input() smallHeaderAlways = false;
  @Input() pais = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    if (
      this.router.url.indexOf('#swiper-itinerario') > 0 ||
      this.router.url.indexOf('#contacto') > 0 ||
      this.router.url.indexOf('#el-viaje') > 0 ||
      this.router.url.indexOf('#rifas') > 0 ||
      this.router.url.indexOf('#alianzas-convenios') > 0 ||
      this.router.url.indexOf('#preguntas') > 0
    ) {
      this.initModal = false;
    }
  }

  ngOnInit(): void {
    if (this.pais) {
      this.initModal = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  doSomething(event) {
    const mainSlideHeight = this.mainSlide.nativeElement.offsetHeight;
    if (isPlatformBrowser(this.platformId)) {
      if (mainSlideHeight * 0.7 < window.pageYOffset) {
        this.smallHeader = true;
      } else {
        this.smallHeader = false;
      }
    }
  }

  openMenu() {
    this.menu = true;
  }

  closeMenu() {
    this.menu = false;
  }

  closeInitModal() {
    this.initModal = false;
  }

  closeAppModal() {
    this.menu = false;
    this.initModal = false;
    this.appViaje = false;
    this.appBeneficios = false;
  }

  openAppViaje() {
    this.initModal = true;
    this.appViaje = true;
  }
  openAppBeneficios() {
    this.initModal = true;
    this.appBeneficios = true;
  }
}
